'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getBoundingClientRect } from '../utils/dom.js'


var _mathExtension = require('../utils/math-extension.js');

var _touch = require('../utils/touch.js');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var dom = weex.requireModule('dom');

var getBoundingClientRect = function getBoundingClientRect(element, func) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

  setTimeout(function () {
    return dom && dom.getComponentRect(element, func);
  }, delay);
};

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    value: {
      type: [Number, Array], // Number为单点滑杆， Array为双侧滑杆
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    trackHeight: {
      type: Number,
      default: 40
    },
    trackColor: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'brand'
    },
    barColor: {
      type: String,
      default: ''
    },
    buttonColor: {
      type: String,
      default: '#ffffff'
    },
    buttonSize: {
      type: Number,
      default: 0
    },
    delay: {
      type: Number,
      default: 50
    },
    gradientBarConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data: function data() {
    return {
      touch: _touch.Touch.Create(),
      current: 0,
      startValue: 0,
      width: 0,
      dragTargetIndex: null, // 0 1
      startRight: null,
      prevScreenX: null,
      isTouching: false,
      isShow: false,
      getWidthRectTime: 0
    };
  },

  watch: {
    barStyle: function barStyle() {
      this.isShow = true;
    }
  },
  computed: {
    _gradientBarConfig: function _gradientBarConfig() {
      if (this.gradientBarConfig.start && this.gradientBarConfig.end) return this.gradientBarConfig;
      return this._isColmo ? { start: '#124AFE', mid: '#ffffff', end: '#E55225' } : {};
    },
    _buttonSize: function _buttonSize() {
      if (this.buttonSize) return this.buttonSize;
      return this._isColmo ? 40 : 24;
    },

    // 是否双侧
    isBoth: function isBoth() {
      return Object.prototype.toString.call(this.value) === '[object Array]';
    },

    // 是否细bar
    isGradientBar: function isGradientBar() {
      return this._gradientBarConfig.start && this._gradientBarConfig.end;
    },
    scope: function scope() {
      return this.max - this.min;
    },
    interactive: function interactive() {
      return !this.disabled && !this.readonly;
    },
    _trackHeight: function _trackHeight() {
      if (this.isGradientBar || this.trackHeight < this._buttonSize) return this._buttonSize * 1.6;
      return this.trackHeight;
    },
    trackStyle: function trackStyle() {
      var res = {
        height: this._trackHeight + 'px',
        backgroundColor: this.trackColor || (this._isDiablo ? '#45494C' : '#F6F7F9'),
        borderRadius: this._trackHeight / 2 + 'px'
        // 细bar样式
      };if (this.isGradientBar || this.trackHeight < this._buttonSize) {
        res.backgroundColor = 'transparent';
      }
      return res;
    },
    barStyle: function barStyle() {
      var percent = 0;
      if (this.isBoth) {
        percent = (Math.min(this.value[1], this.max) - Math.max(this.value[0], this.min)) / this.scope;
      } else {
        percent = (this.value - this.min) / this.scope;
      }

      // const width = ((this.value - this.min) / this.scope) * this.width
      // const widthCss = clamp(width+this._trackHeight, this._trackHeight, this.width)

      // fix: 修复value带来的width小于this._trackHeight时，bar宽度不变
      var width = percent * this.width;
      var widthCss = this._trackHeight;
      if (percent < 0) {
        widthCss = this._trackHeight;
      } else if (percent > 1) {
        widthCss = this.width + this._trackHeight;
      } else {
        // 正常滑动
        widthCss = width + this._trackHeight;
      }
      var res = {
        width: widthCss + 'px',
        borderRadius: this._trackHeight / 2 + 'px',
        height: this._trackHeight + 'px'
      };

      if (this.isBoth) res.left = (Math.max(this.value[0], this.min) - this.min) / this.scope * this.width + 'px';

      // if (this.barColor) {
      //   res.backgroundColor = this.barColor
      // }
      // 细bar样式
      // if (this.isGradientBar) {
      res.backgroundColor = 'transparent';
      // }
      return res;
    },
    smallBarStyle: function smallBarStyle() {
      var buttonPadding = this.trackHeight > this._buttonSize ? 0 : (this._trackHeight - this._buttonSize) / 2 + 1;
      var res = {
        position: 'absolute',
        top: (this._trackHeight - this.trackHeight) / 2 + 'px',
        left: buttonPadding + 'px',
        right: buttonPadding + 'px',
        height: this.trackHeight + 'px',
        borderRadius: this.trackHeight / 2 + 'px'
      };
      if (this.barColor) {
        res.backgroundColor = this.barColor;
      }
      return res;
    },
    buttonStyle: function buttonStyle() {
      var buttonSize = this._buttonSize;
      var res = {
        top: (this._trackHeight - buttonSize) / 2 + 'px',
        width: buttonSize + 'px',
        height: buttonSize + 'px',
        borderRadius: buttonSize / 2 + 'px',
        backgroundColor: this.buttonColor
      };
      var buttonPadding = (this._trackHeight - buttonSize) / 2;
      return this.isBoth ? [_extends({}, res, { left: buttonPadding + 'px' }), _extends({}, res, { right: buttonPadding + 'px' })] : [_extends({}, res, { right: buttonPadding + 'px' })];
    },
    lineStyle: function lineStyle() {
      var buttonPadding = (this._trackHeight - this._buttonSize) / 2 + 1;
      var res = {
        position: 'absolute',
        top: (this._trackHeight - this.trackHeight) / 2 + 'px',
        left: buttonPadding + 'px',
        right: buttonPadding + 'px',
        height: this.trackHeight + 'px',
        borderRadius: this.trackHeight / 2 + 'px'
        // if (this.trackColor) {
      };res.backgroundColor = this.trackColor || (this._isDiablo ? '#45494C' : '#F6F7F9');
      // }
      return res;
    },
    thinBarStyle: function thinBarStyle() {
      var buttonPadding = (this._trackHeight - this._buttonSize) / 2;
      var res = {
        top: (this._trackHeight - 4) / 2 + 'px',
        left: buttonPadding + 'px',
        right: buttonPadding + 'px',
        height: '4px'
      };
      return res;
    },
    midWidth: function midWidth() {
      return this.width / 2;
    },
    disabledStyle: function disabledStyle() {
      if (!this.isShow) return { opacity: 0 };
      return this.isGradientBar && this.disabled ? { opacity: 0.3 } : { opacity: 1 };
    }
  },
  mounted: function mounted() {
    this.getRect();
  },

  methods: {
    getRect: function getRect() {
      var _this = this;

      getBoundingClientRect(this.$refs.track, function (res) {
        if (res.result && res.size.width !== 0) {
          // 实际可滑动长度（可变化范围）= bar宽度 - btn宽度
          _this.width = res.size.width - _this._trackHeight;
        } else {
          _this.getWidthRectTime < 6 ? setTimeout(function () {
            _this.getWidthRectTime++;
            _this.getRect();
          }, 50) : _this.width = res.size.width - _this._trackHeight;
        }
      }, this.delay);
    },
    onTouchStart: function onTouchStart(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref, left, right, startX;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.interactive) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (_this2.isGradientBar) _this2.isTouching = true;
                _this2.touch.start(e);

                if (!_this2.isBoth) {
                  _context.next = 16;
                  break;
                }

                _context.next = 7;
                return _this2.getBarRect();

              case 7:
                _ref = _context.sent;
                left = _ref.left;
                right = _ref.right;
                startX = _this2.touch.startX;

                _this2.startRight = right;
                _this2.dragTargetIndex = Math.abs(left - startX) < Math.abs(right - startX) ? 0 : 1;
                _this2.current = _this2.value[_this2.dragTargetIndex];
                _context.next = 17;
                break;

              case 16:
                _this2.current = _this2.value;

              case 17:

                _this2.startValue = _this2.format(_this2.current);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onTouchMove: function onTouchMove(e) {
      if (!this.interactive) {
        return;
      }

      this.touch.move(e);

      var delta = this.touch.deltaX;
      if (this.isBoth && this.value[0] === this.value[1]) {
        this.dragTargetIndex = e.changedTouches[0].screenX > this.prevScreenX ? 1 : 0;
        if (delta === 0) {
          this.dragTargetIndex = this.touch.startX >= this.startRight ? 1 : 0;
        }
      }

      var total = this.width;
      var diff = delta / total * this.scope;

      this.current = this.startValue + diff;
      this.prevScreenX = e.changedTouches[0].screenX;

      if (delta === 0) return;
      this.update(this.current);
    },
    onTouchEnd: function onTouchEnd(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var total, _ref2, left, right, diff;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.interactive) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this3.isTouching = false;
                // 点按

                if (!(_this3.startValue === _this3.current)) {
                  _context2.next = 12;
                  break;
                }

                total = _this3.width;
                _context2.next = 7;
                return _this3.getBarRect();

              case 7:
                _ref2 = _context2.sent;
                left = _ref2.left;
                right = _ref2.right;
                diff = (_this3.touch.startX - (_this3.dragTargetIndex === 0 ? left : right)) / total * _this3.scope;

                _this3.current = _this3.startValue + diff;

              case 12:
                _this3.update(_this3.current, true);
                _this3.$emit('dragend', e);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    format: function format(value) {
      var min = +this.min;
      var max = +this.max;
      var step = +this.step;

      var val = (0, _mathExtension.clamp)(value, min, max);
      if (this.isBoth) {
        this.dragTargetIndex === 1 && (val = (0, _mathExtension.clamp)(value, this.value[0], max));
        this.dragTargetIndex === 0 && (val = (0, _mathExtension.clamp)(value, min, this.value[1]));
      }

      var diff = Math.round((val - min) / step) * step;

      return min + diff;
    },
    update: function update(value) {
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var val = null;
      if (this.isBoth) {
        if (this.dragTargetIndex === 0) {
          val = [this.format(value), this.value[1]];
        }
        if (this.dragTargetIndex === 1) {
          val = [this.value[0], this.format(value)];
        }
      } else {
        val = this.format(value);
      }
      ;(!this.isBoth || this.dragTargetIndex !== null) && this.$emit('input', val);
      if (end) {
        this.$emit('change', val);
      }
    },
    getBarRect: function getBarRect() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        getBoundingClientRect(_this4.$refs.bar, function (res) {
          if (res.result) {
            resolve({
              left: res.size.left,
              right: res.size.right
            });
          }
        }, 0);
      });
    },
    maskTouchStart: function maskTouchStart() {}
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-slider/index.vue
// module id = 390
// module chunks = 0 1